import React from 'react';

class History extends React.Component {

    componentDidMount() {
        document.querySelector("main").scrollIntoView();
    }

    render() {
        return(
            <div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 g-pb-50">
                            <div className="row g-pt-20">
                                <div className="col-md-3">
                                    <h3 className="h3 g-font-weight-600 g-pl-10 g-pl-10">2018</h3>
                                </div>
                                <div className="col-md-9">
                                    <ul className="list-unstyled g-pl-20">
                                        <li className="mb-2">학생과 교사를 위한 동물보호교육 책자 [동물친화적 학교 만들기] 발간</li>
                                        <li className="mb-2">고돌북스: [개를 키울 수 있는 자격, 동물을 대하는 나라의 품격]</li>
                                        <li className="mb-2">강동구 초등학교 3학년 전 학급 찾아가는 교육 실시</li>
                                        <li className="mb-2">고돌북스: 동물보호법 판례 평석</li>
                                        <li className="mb-2">동물친화적 학교 만들기 컨테스트 개최</li>
                                        <li className="mb-2">고돌북스: 야생동물 스폐셜 [야생동물과 공존하는 지혜로운 인간이 되기 위한 지침서]</li>
                                        <li className="mb-2">도서관 동물x인문사회 프로그램 [너처럼 나도 나이가 든다]</li>
                                        <li className="mb-2">도서관 전시 [동물권을 헌법에: 동물과 인간은 이 세상의 동등한 창조물이다]</li>
                                        <li className="mb-2">6.13 지방선거 및 교육감 선거 대응 [동물을 위한 투표] 캠페인</li>
                                        <li className="mb-2">청소년 동물권 활동가 교육 프로그램[틴카라]</li >
                                        <li className="mb-2">도서관 전시[틴카라: 우리들의 나비효과]</li >
                                        <li className="mb-2">제1회 카라 동물영화제 개최 및 초청 간담회[사랑, 자유, 바나나: 상둔 렉 차일러와 코끼리 이야기]</li >
                                        <li className="mb-2">도서관 전시[함께 숨, 쉼: 카라 2019년 달력 원화 전시]</li >
                                        <li className="mb-2">서울시교육청 동물친화적 학교 만들기 설명회</li >
                                        <li className="mb-2">동물권 활동가를 위한 인권길라잡이 발간</li >
                                    </ul>
                                </div>
                            </div>

                            <hr />

                            <div className="row g-pt-10">
                                <div className="col-md-3">
                                    <h3 className="h3 g-font-weight-600 g-pl-10">2017</h3>
                                </div>
                                <div className="col-md-9">
                                    <ul className="list-unstyled g-pl-20">
                                        <li className="mb-2">번개 영화 상영회 [더 코브: 슬픈 돌고래의 진실]</li>
                                        <li className="mb-2">도서관 전시 . 문선희 사진전 '묻다', 작가와의 대화</li>
                                        <li className="mb-2">어린이, 청소년 동물해부실습 금지법 발의 서명운동</li>
                                        <li className="mb-2">동물학대나 다름없는 '만지기' 생태체험 고발</li>
                                        <li className="mb-2">고돌북스 생명토크: '인간이 만들어내고 비인간동물에게만 벌어지는 비극'</li>
                                        <li className="mb-2">세계실험동물의 날 기념 SNS행동, 미성년자 해부실험 금지 서명 국회 농해수위 제출</li>
                                        <li className="mb-2">강동구청, 관악구청, 인천대교 연계 찾아가는 동물보호교육 진행</li>
                                        <li className="mb-2">도서관 전시.최소영 작가 삽화전[10대와 통하는 동물권리 이야기]</li >
                                        <li className="mb-2">고돌북스 생명토크: '10대와 통하는 동물 권리 이야기'</li >
                                    </ul>
                                </div>
                            </div>

                            <hr />

                            <div className="row g-pt-10">
                                <div className="col-md-3">
                                    <h3 className="h3 g-font-weight-600 g-pl-10">2016</h3>
                                </div>
                                <div className="col-md-9">
                                    <ul className="list-unstyled g-pl-20">
                                        <li className="mb-2">고돌씨네 생명극장 ‘우리 체제의 유령들’</li>
                                        <li className="mb-2">고돌씨네 생명극장 ‘치타, 칸지, 너클스’</li>
                                        <li className="mb-2">‘음식 너머의 생명’ 전시회 산란계 배터리 케이지, 돼지 스톨 전시</li>
                                        <li className="mb-2">고돌씨네 생명극장 ‘스톡홀름 씨의 좋은 날’</li>
                                        <li className="mb-2">고돌씨네 생명극장 ‘화이트 갓’</li>
                                        <li className="mb-2">2015 동물보호명예감시원 활동사례집 발간</li>
                                        <li className="mb-2">고돌북스 생명토크 ‘우리 아이가 아파요’</li>
                                        <li className="mb-2">고돌북스 생명토크 ‘재난의 시대, 떠나지 못하는 동물들’</li >
                                        <li className="mb-2">어린이 청소년 동물 해부실습에 대한 제재 요청</li >
                                        <li className="mb-2">고돌북스 생명토크 ‘당신은 개를 키우면 안된다’</li >
                                        <li className="mb-2">고돌북스 생명토크 ‘동물 해방’</li >
                                        <li className="mb-2">고돌북스 생명토크 ‘고기, 먹을수록 죽는다’</li >
                                        <li className="mb-2">고돌북스 생명토크 '생명'</li >
                                        <li className="mb-2">관악구청 연계 찾아가는 동물보호교육 시작</li >
                                        <li className="mb-2">서울시교육청 연계 찾아가는 동물보호교육 진행 & 동물복지교육자료 개발 참여</li >
                                    </ul>
                                </div>
                            </div>

                            <hr />

                            <div className="row g-pt-10">
                                <div className="col-md-3">
                                    <h3 className="h3 g-font-weight-600 g-pl-10">2015</h3>
                                </div>
                                <div className="col-md-9">
                                    <ul className="list-unstyled g-pl-20">
                                        <li className="mb-2">프리 오랑(Free Orang) 프로젝트, 북콘서트 및 강연회 개최</li>
                                        <li className="mb-2">인천대교 사회공헌팀 연계 찾아가는 동물보호교육 실시</li>
                                        <li className="mb-2">제주도지역 동물보호강사양성 교육</li>
                                        <li className="mb-2">수도권지역 동물보호강사양성 심화워크숍</li>
                                        <li className="mb-2">부산지역 동물보호강사양성 교육</li>
                                        <li className="mb-2">강동구청 연계 찾아가는 동물보호교육 시작</li>
                                        <li className="mb-2">동물보호 청소년 공모전 ‘너의 생명 나의 공감’ 실시</li>
                                    </ul>
                                </div>
                            </div>

                            <hr />

                            <div className="row g-pt-10">
                                <div className="col-md-3">
                                    <h3 className="h3 g-font-weight-600 g-pl-10">2014</h3>
                                </div>
                                <div className="col-md-9">
                                    <ul className="list-unstyled g-pl-20">
                                        <li className="mb-2">생명공감 청소년, 동물과 만나다, ‘영카라’ 출범</li>
                                        <li className="mb-2">경기교육청, 서울시교육청 교사 특수분야 직무연수</li>
                                        <li className="mb-2">세계실험동물의 날 맞이, ‘화장품동물실험반대’ 홈페이지 </li>
                                        <li className="mb-2">2014 동물보호교육 강사양성 워크숍</li>
                                        <li className="mb-2">카라 기획, 감수 [동물홀로코스트] 출간</li>
                                        <li className="mb-2">학생을 이용해 동물을 살처분, 판매한 한국바이오마이스터고 고발</li>
                                        <li className="mb-2">제인 구달과 함께 하는 영화 [제인 구달] 시사회 참여</li>
                                    </ul>
                                </div>
                            </div>

                            <hr />

                            <div className="row g-pt-10">
                                <div className="col-md-3">
                                    <h3 className="h3 g-font-weight-600 g-pl-10">2013</h3>
                                </div>
                                <div className="col-md-9">
                                    <ul className="list-unstyled g-pl-20">
                                        <li className="mb-2">동물사랑교과서 출간</li>
                                        <li className="mb-2">임순례 대표와 함께 하는 생명권 토크</li>
                                        <li className="mb-2">동물보호 강사 양성 기초교육 워크숍/활동가 실천 워크숍</li>
                                        <li className="mb-2">Send Your Love Project!! "당신의 사랑을 날려주세요~" 동물보호교육센터 캠페인</li>
                                        <li className="mb-2">찾아가는 동물보호교육 ‘함께라서 고마워’ 행사</li>
                                        <li className="mb-2">2013 동물보호명예감시원 교육 진행</li>
                                        <li className="mb-2">영화 [블랙피쉬] 무료상영회 개최</li>
                                    </ul>
                                </div>
                            </div>

                            <hr />

                            <div className="row g-pt-10">
                                <div className="col-md-3">
                                    <h3 className="h3 g-font-weight-600 g-pl-10">2012</h3>
                                </div>
                                <div className="col-md-9">
                                    <ul className="list-unstyled g-pl-20">
                                        <li className="mb-2">제9회 서울환경영화제 참여</li>
                                        <li className="mb-2">동물보호무크지 ‘숨’ 3집 발간</li>
                                        <li className="mb-2">‘동물 체험 및 전시 반대’ 캠페인 포스터 배포</li>
                                    </ul>
                                </div>
                            </div>

                            <hr />

                            <div className="row g-pt-10">
                                <div className="col-md-3">
                                    <h3 className="h3 g-font-weight-600 g-pl-10">2011</h3>
                                </div>
                                <div className="col-md-9">
                                    <ul className="list-unstyled g-pl-20">
                                        <li className="mb-2">2011 동물보호명예감시관 서울/대구/광주 교육</li>
                                        <li className="mb-2">13회 서울국제여성영화제 참여</li>
                                        <li className="mb-2">제8회 환경영화제 홍보부스 참여</li>
                                    </ul>
                                </div>
                            </div>

                            <hr />

                            <div className="row g-pt-10">
                                <div className="col-md-3">
                                    <h3 className="h3 g-font-weight-600 g-pl-10">2010</h3>
                                </div>
                                <div className="col-md-9">
                                    <ul className="list-unstyled g-pl-20">
                                        <li className="mb-2">‘먹는 개, 귀동이’ 환경영화제 초청</li>
                                        <li className="mb-2">2010 동물보호명예감시관 교육진행</li>
                                    </ul>
                                </div>
                            </div>

                            <hr />

                            <div className="row g-pt-10">
                                <div className="col-md-3">
                                    <h3 className="h3 g-font-weight-600 g-pl-10">2009</h3>
                                </div>
                                <div className="col-md-9">
                                    <ul className="list-unstyled g-pl-20">
                                        <li className="mb-2">동물해부실습에 대한 공문. 인천 교육청의 조치</li>
                                        <li className="mb-2">숨 2집, ‘반려동물, 그 아름답고도 오랜 우정’ 출간</li>
                                    </ul>
                                </div>
                            </div>

                            <hr />

                            <div className="row g-pt-10">
                                <div className="col-md-3">
                                    <h3 className="h3 g-font-weight-600 g-pl-10">2008</h3>
                                </div>
                                <div className="col-md-9">
                                    <ul className="list-unstyled g-pl-20">
                                        <li className="mb-2">황윤 감독 [어느 날 그 길에서], [작별] KARA 가족 시사회</li>
                                        <li className="mb-2">동물보호명예감시관 교육 참석 및 이수</li>
                                    </ul>
                                </div>
                            </div>

                            <hr />

                            <div className="row g-pt-10">
                                <div className="col-md-3">
                                    <h3 className="h3 g-font-weight-600 g-pl-10">2007</h3>
                                </div>
                                <div className="col-md-9">
                                    <ul className="list-unstyled g-pl-20">
                                        <li className="mb-2">어린이 청소년 전용 공간 ‘영카라’ 오픈</li>
                                        <li className="mb-2">한국 최초 동물보호잡지 ‘숨’ 창간</li>
                                    </ul>
                                </div>
                            </div>

                            <hr />

                            <div className="row g-pt-10">
                                <div className="col-md-3">
                                    <h3 className="h3 g-font-weight-600 g-pl-10">2006</h3>
                                </div>
                                <div className="col-md-9">
                                    <ul className="list-unstyled g-pl-20">
                                        <li className="mb-2">KARA 도서관 온라인/오프라인 개설</li>
                                        <li className="mb-2">영화 [우리 개 이야기] KARA 가족 시사회</li>
                                    </ul>
                                </div>
                            </div>

                            <hr />

                            <div className="row g-pt-10">
                                <div className="col-md-3">
                                    <h3 className="h3 g-font-weight-600 g-pl-10">2005</h3>
                                </div>
                                <div className="col-md-9">
                                    <ul className="list-unstyled g-pl-20">
                                        <li className="mb-2">카라 비영리단체 정식 승인</li>
                                    </ul>
                                </div>
                            </div>

                            <hr />

                            <div className="row g-pt-10">
                                <div className="col-md-3">
                                    <h3 className="h3 g-font-weight-600 g-pl-10">2004</h3>
                                </div>
                                <div className="col-md-9">
                                    <ul className="list-unstyled g-pl-20">
                                        <li className="mb-2">대안학교 '꿈꾸는 아이들의 학교'와 함께 동물사랑 교육</li>
                                    </ul>
                                </div>
                            </div>

                            <hr />

                            <div className="row g-pt-10">
                                <div className="col-md-3">
                                    <h3 className="h3 g-font-weight-600 g-pl-10">2003</h3>
                                </div>
                                <div className="col-md-9">
                                    <ul className="list-unstyled g-pl-20">
                                        <li className="mb-2">휘문고 고양이해부사건에 대한 항의서한 및 학교 내 해부교육에 대한 대안정보 전달</li>
                                    </ul>
                                </div>
                            </div>

                            <hr />

                            <div className="row g-pt-10">
                                <div className="col-md-3">
                                    <h3 className="h3 g-font-weight-600 g-pl-10">2002</h3>
                                </div>
                                <div className="col-md-9">
                                    <ul className="list-unstyled g-pl-20">
                                        <li className="mb-2">아름품 창립</li>
                                    </ul>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default History;


// WEBPACK FOOTER //
// ./src/pages/front/home/history.js